function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";

var JSONLDAbstractNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(JSONLDAbstractNode, _React$Component);

  function JSONLDAbstractNode() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = JSONLDAbstractNode.prototype;

  _proto.getChildJSON = function getChildJSON(child) {
    var _Object$assign;

    if (!child) {
      return null;
    }

    if (Array.isArray(child) && child.length === 0) {
      return null;
    }

    var ChildClass = child.type;

    var _child$props = child.props,
        children = _child$props.children,
        type = _child$props.type,
        id = _child$props.id,
        schema = _objectWithoutPropertiesLoose(_child$props, ["children", "type", "id"]);

    var newChildren = new ChildClass(child.props).getJSON(id ? _objectSpread({}, schema, {
      "@id": id
    }) : schema);
    return type ? Object.assign((_Object$assign = {}, _Object$assign[type] = newChildren, _Object$assign)) : newChildren;
  };

  _proto.parseChildren = function parseChildren() {
    var _this = this;

    if (!this.props.children) {
      return {};
    }
    /*
     * If a component has a single child, this.props.children is a Child object.
     * If a component has multiple children, this.props.children is an array of Child objects.
     */


    if (this.props.children.length > 0) {
      // Children that are null will get filtered out
      return this.props.children.map(function (child) {
        return _this.getChildJSON(child);
      }).filter(function (child) {
        return child;
      });
    }

    var childJSON = this.getChildJSON(this.props.children);
    return childJSON ? [childJSON] : null;
  };

  _proto.render = function render() {
    return null;
  };

  _proto.getSchemaOrgType = function getSchemaOrgType() {
    return "";
  };

  return JSONLDAbstractNode;
}(React.Component);

process.env.NODE_ENV !== "production" ? JSONLDAbstractNode.propTypes = {
  schema: PropTypes.object,
  type: PropTypes.string,
  id: PropTypes.string,
  jsonldtype: PropTypes.string,
  children: PropTypes.node
} : void 0;
export default JSONLDAbstractNode;